export const LANGUAGES = [
  {
    text: "English",
    value: "en",
  },
  {
    text: "Spanish",
    value: "es",
  },
];
